<template>
  <div>
    <Form :label-width="80" inline>
      <FormItem label="项目名称">
        <Input v-model="searchValue.articleName" placeholder="请输入项目名称搜索" style="width:300px;">
        </Input>
      </FormItem>
      <FormItem label="项目简编">
        <Input v-model="searchValue.projectNumAbbr" style="width:100px;"></Input>
        <Button type="primary" style="margin-left:10px;" @click="searchArticles">搜索</Button>
      </FormItem>
    </Form>
    <Table style="margin-top:10px;" :columns="articleColumns" :data="articleList"></Table>
    <Page ref="page" style="margin-top:10px;" :page-size="8" :total="totalArticles" show-elevator show-total @on-change="changePage"></Page>
  </div>
</template>

<script>
// import axios from 'axios'
import ajax from '../lib/ajax'
import requestUrls from '../lib/requestUrls'

export default {
  data() {
    return {
      articleColumns: [
        {
          title: '项目名称',
          key: 'projectName'
        },
        {
          title: '项目简编',
          key: 'projectShort',
          width: 120
        },
        {
          title: '操作',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.importArticle(params.row)
                  }
                }
              }, '选择'),
            ]);
          }
        }
      ],
      articleList: [],
      totalArticles: 0,
      searchValue: {
        articleName: '',
        projectNumAbbr: ''
      },
    }
  },
  created() {
    this.initArticles()
  },
  methods: {
    async initArticles() {
      let rep = await ajax.get(requestUrls.ClProjectDb.getPaged, {
        params: {
          maxResultCount: 8,
          skipCount: 0,
          filter: '',
          sorting: 'newProjectTime desc'
        }
      })
      if (rep.data.success) {
        this.articleList = rep.data.result.items
        this.totalArticles = rep.data.result.totalCount
      }
    },
    async getArticles(page, searchValue) {
      let searArticleName = searchValue.articleName ? ` and projectName.Contains("${searchValue.articleName}")` : ''
      let searNumAbbr = searchValue.projectNumAbbr ? ` and projectShort.Contains("${searchValue.projectNumAbbr}")` : ''
      let filter = searArticleName + searNumAbbr
      filter = filter.slice(5)
      let rep = await ajax.get(requestUrls.ClProjectDb.getPaged, {
        params: {
          maxResultCount: 8,
          skipCount: (page - 1)*8,
          filter: filter,
          sorting: 'newProjectTime desc'
        }
      })
      if (rep.data.success) {
        this.articleList = rep.data.result.items
        this.totalArticles = rep.data.result.totalCount
        if (page === 1) {
          this.$refs.page.currentPage = 1
        }
      }
    },
    changePage(page) {
      this.getArticles(page, this.searchValue)
    },
    searchArticles() {
      this.getArticles(1, this.searchValue)
    },
    importArticle(article) {
      this.$emit('endImport', article)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
